export const baseUrl = '/customer-invoices'
